/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';

import { useDispatch, useSelector } from 'react-redux'; import { CallContext, LanguageContext } from '../../../../../../../libs/Context';
import Loading from '../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { PRESENCE_ENUMS } from '../../../../../../../libs/enums/presenceEnums';
import { setCallDetails, setEachCallDetailChanges } from '../../../../../../../redux/PresenceRedux';
import { updateDocByDocumentId } from '../../../../../../../utils/Firebase/firebaseQuery';
import { setAudioCall, setVideoCall } from '../../../../../../../redux/CallsRedux';
import { updateDeviceData } from '../../../../../../../utils/CollaborationUtils';

function GroupCallPresence(props)
{
	const [ isLoading, setIsLoading ] = useState(true);
	const isOpenParticipantTab = useRef(false);
	const userInfo = useSelector((state:any) => state?.mysession?.session);
	const myPresence = useSelector((state:any) => state?.mypresence);
	const { audioCall, videoCall } = useSelector((state:any) => state.call);
	const iframeRef = useRef<any>(null);
	const timers = {};
	const [ minimize ] = useState(false);
	const dispatch = useDispatch();

	const sendCallDataToVc = () =>
	{
		const message = {
			command : 'groupMemberList',
			value   : { groupList: myPresence?.callDetails?.participants, callDetails: myPresence?.callDetails }
		};

		iframeRef.current.contentWindow.postMessage(message, '*');
	};

	useEffect(() =>
	{
		if (isOpenParticipantTab.current)
		{
			console.log('diuasdasid asdia daid adia dadsad', myPresence?.callDetails);

			sendCallDataToVc();
		}

		// Listen for messages from the child iframe
		const handleMessage = async (event) =>
		{
			console.log('messagemessagemessage, reconnection reconnectionreconnection', event, event.data);

			// Handle the message from the iframe
			if (event.data.cmd === 'getGroupUsersData')
			{
				isOpenParticipantTab.current = true;
				//  const groupPeerList = presenceUserChatList?.find((eachChat)=>eachChat?.id === myPresence?.callDetails?.groupId)?.membersDetails

				//  let activeGroupPeerList = []

				//  if(groupPeerList && groupPeerList?.length > 0){
				//     activeGroupPeerList = groupPeerList?.filter((eachMember)=>!eachMember?.removedStatus?.status);
				//  }

				// console.log('Received from iframe:', activeGroupPeerList, event.data);

				sendCallDataToVc();
			}
			else if (event.data.cmd === 'leaveGroupCall')
			{
				// try {
				//     // console.log("CALL DETAILS", myPresence?.callDetails);
				//     const { callId, groupId } = myPresence?.callDetails;

				//     // Create the request body with the required fields
				//     const requestBody = {
				//         messageId: callId,
				//         groupId: groupId,
				//         userId: userInfo?.userId
				//     };

				//     // Call the API with the constructed body
				//     endGroupCallAPI(requestBody)
				//         .then((res) => {
				//             console.log("Group call ended successfully:", res);
				//         })
				//         .catch((err) => {
				//             console.error("Error ending call:", err);
				//         });

				// } catch (error) {
				//     console.error('Error in leaveGroupCall handler:', error);
				// }
			}
			else if (event.data.cmd === 'participantTabClosed')
			{
				isOpenParticipantTab.current = false;
			}
			else if (event.data.cmd === 'PresenceEndCall')
			{
				console.log('saidds  daida dia dadia sdais dadsads ad', myPresence?.callDetails);
				audioCall && dispatch(setAudioCall(''));
				videoCall && dispatch(setVideoCall(''));

				try
				{
					// const deviceData = JSON.parse(sessionStorage.getItem('deviceData'));
					const statusData = {
						status    : 'online',
						timestamp : Date.now()
					};
					// await userOnlineStatus(userInfo?.userId, deviceData?.deviceId, statusData);
					// sessionStorage.setItem('deviceData', JSON.stringify({ ...statusData, deviceId: deviceData?.deviceId }));

					await updateDeviceData(statusData, userInfo?.userId);

					// await userOnlineOfflineStatusRef?.updateStatus({
					// 	status : 'online'
					// });
					props.closeCall();
				}
				catch (err)
				{
					console.log('error===', err);
				}

				dispatch(setCallDetails(null));
			}
			else if (event?.data?.cmd === 'reconnection' && event?.data?.value?.isReconnected)
			{
				console.log('reconnection reconnectionreconnection', event);
				console.log('userInfo.userIduserInfo.userId', userInfo.userId);
				console.log('callDetailscallDetails', myPresence?.callDetails);

				setIsLoading(false);

				// console.log('callDetailscallDetailscallDetailscallDetailscallDetails', myPresence?.callDetails);

				// eslint-disable-next-line max-len
				// if (userInfo.userId && myPresence?.callDetails?.participants[userInfo.userId]?.status !== PRESENCE_ENUMS.accepted) {
				const updateDocumentBody = { [`callDetails.participants.${userInfo.userId}.status`]: PRESENCE_ENUMS.connected };

				await updateDocByDocumentId('messages', myPresence?.callDetails?.callId, updateDocumentBody);
				// }
			}
			else if (event?.data?.cmd === 'timerForRinRingAll')
			{
				for (const each of event?.data?.value?.data || [])
				{
					const timerId = setTimeout(async () =>
					{
						console.log('each-=============', each);
						console.log('dsadasdasdd', myPresence?.callDetails, myPresence?.callDetails);

						const user = myPresence?.callDetails?.participants[each];

						console.log('isStatus', user);

						if (user?.status === PRESENCE_ENUMS.invited || user?.status === PRESENCE_ENUMS.ringing)
						{
							console.log('invited==========================', timers);
							const updateDocumentBody = { [`myPresence?.callDetails?.participants.${each}.status`]: PRESENCE_ENUMS.missed };

							try
							{
								await updateDocByDocumentId('messages', myPresence?.callDetails?.callId, updateDocumentBody);
							}
							catch (err)
							{
								// console.log('error', err)
							}
							clearTimeout(timers[each]);

							delete timers[each];
						}
					}, 40000);

					timers[each] = timerId;
				}
			}
			else if (event?.data?.cmd === 'leaveMeeting')
			{
				dispatch(setEachCallDetailChanges({ status: PRESENCE_ENUMS.left, groupId: myPresence?.callDetails?.groupId, callId: myPresence?.callDetails?.callId }));
			}
		};
		// // Set the loading state when the iframe starts loading
		// const handleLoadStart = () => setIsLoading(true);

		// Hide the loader once the iframe loads
		const handleLoad = () => setIsLoading(false);

		// Show an error message or keep the loader on error
		const handleError = () => setIsLoading(false);

		window.addEventListener('message', handleMessage);

		if (iframeRef.current)
		{
			iframeRef.current.addEventListener('load', handleLoad);
			iframeRef.current.addEventListener('error', handleError);
		}

		// Cleanup the event listener on component unmount
		return () =>
		{
			window.removeEventListener('message', handleMessage);
			if (iframeRef.current)
			{
				iframeRef.current.removeEventListener('load', handleLoad);
				iframeRef.current.removeEventListener('error', handleError);
			}
		};
	}, [ myPresence?.callDetails ]);

	return (
		<Draggable bounds='body' disabled={!minimize} >
			<div className='flexRow webinarJoinScreen alignCntr justifyCntr'>
				<div className='flexCol webinarFullScreen justifyBtwn'>
					{/* <div className={`flexAutoCol conference ${minimize ? 'minimize' : 'maximize'}`} > */}
					{myPresence?.callDetails?.type === PRESENCE_ENUMS.group && (
						<div style={{ height: '100vh', width: '100%', position: 'relative' }}>
							{isLoading && (
								<Loading />
							)}
							<iframe
								ref={iframeRef}
								loading='lazy'
								// src={`https://10.10.40.220:4443/${myPresence?.callDetails?.sessionId ?? ''}?projectId=${process.env.REACT_APP_VIDEO_ID}&uid=${window.btoa(userInfo?.email?.toLowerCase())}&displayName=${window.btoa(userInfo?.firstName)}&meetingType=cHJlc2VuY2U=&profileKey=${userInfo?.userId}&lan=en&presenceUserId=${userInfo?.userId}&env=${process.env.REACT_APP_STAGE}`}
								src={`${process.env.REACT_APP_MEETINGS_INMEET_CLIENT}${myPresence?.callDetails?.sessionId ?? ''}?projectId=${process.env.REACT_APP_VIDEO_ID}&uid=${window.btoa(userInfo?.email?.toLowerCase())}&displayName=${window.btoa(userInfo?.name)}&meetingType=cHJlc2VuY2U=&profileKey=${userInfo?.userId}&lan=en&presenceUserId=${userInfo?.userId}&env=${process.env.REACT_APP_STAGE}`}
								style={{ border: 'none', width: '100%', height: '100%' }}
								title='External Page'
								allow='camera; microphone; display-capture; autoplay fullscreen;'
								allowFullScreen
								onLoad={() => setIsLoading(false)} // Hide loader on successful load
								onError={() => setIsLoading(false)}
							/>
						</div>
					)
					}
				</div>
			</div>
		</Draggable>
	);
}

export default GroupCallPresence;